/* eslint-disable import/no-cycle */
import React, { useEffect } from 'react'
import { History, Location } from 'history'
import { match as Match } from 'react-router'
import { Row, Col } from 'styled-bootstrap-grid'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import Wizard from '../../../components/Wizard'
import { AddThemeName } from './AddThemeName'
import { Layout, Box } from '../../../components/Page/Layout'
import { Page } from '../../../components/Page'
import { AddBalloonColors } from './AddBalloonColors'
import { selectedTheme } from '../../../features/theme/selectors'
import { ThemeActions } from '../../../features/theme/actions'
import { AddBaseColors } from './AddBaseColors'

type Props = {
  history: History
  location: Location<{ showInDashboard?: boolean } | undefined>
  match?: Match<{ themeId: string }>
}

export const AddThemeContainer = ({ history, match }: Props) => {
  const components: JSX.Element[] = []
  const dispatch = useDispatch()
  const theme = useSelector(selectedTheme)
  const themeId = _.get(match, 'params.themeId')

  useEffect(() => {
    dispatch(ThemeActions.resetNewTheme())
  }, [dispatch])

  useEffect(() => {
    const loadTheme = async () => {
      if (themeId) {
        dispatch(ThemeActions.fetchThemeInfo(themeId))
        dispatch(ThemeActions.updateThemeValidation({ isValid: true }))
      } else {
        dispatch(
          ThemeActions.updateNewTheme({
            name: ''
          })
        )
      }
    }

    loadTheme()

    return () => {
      dispatch(ThemeActions.resetNewTheme())
      dispatch(ThemeActions.updateThemeValidation({ isValid: false }))
    }
  }, [dispatch, themeId])

  const addNewTheme = () => {
    if (theme) {
      dispatch(ThemeActions.startSavingTheme(theme))
    }
  }

  components.push(<AddThemeName key="themename" close={history.goBack} />)
  components.push(<AddBalloonColors key="themeballoon" close={history.goBack} />)
  components.push(<AddBaseColors key="themebasecolor" close={history.goBack} addTheme={addNewTheme} />)
  return (
    <Page>
      <Layout>
        <Row>
          <Col xl={8} lg={10} xlOffset={2} lgOffset={1} md={12}>
            <Box>
              <Wizard stepCount={components.length}>{components}</Wizard>
            </Box>
          </Col>
        </Row>
      </Layout>
    </Page>
  )
}
